export const centerListingConstant = {
  GET_ALL_APPROVED_CENTERS_LIST: "GET_ALL_APPROVED_CENTERS_LIST",
  GET_ALL_APPROVED_CENTERS_LIST_BY_SPOTID: "GET_ALL_APPROVED_CENTERS_LIST_BY_SPOTID",
  GET_CENTER_PROFILE_DATA_BY_ID: "GET_CENTER_PROFILE_DATA_BY_ID",
  GET_ALL_CENTER_INSTRUCTORS_LIST: "GET_ALL_CENTER_INSTRUCTORS_LIST",
  GET_ALL_CENTER_ACTIVITIES: "GET_ALL_CENTER_ACTIVITIES",
};
